var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHububbleConsoleLockupEnWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    role: "img",
    "aria-label": "Hububble SMS Console",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    transform: "translate(0,8) scale(0.2) translate(-140,-140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 140 V362 M161 279.5 A73.5 73.5 0 0 1 308 279.5 V362",
    fill: "none",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 140,
    width: 74,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 140,
    width: 32,
    height: 72,
    stroke: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 26,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "Hububble")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 50,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "SMS Console")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHububbleConsoleLockupEnWhite);
export default __webpack_public_path__ + "static/media/hububble-console-lockup-en-white.17e734972c9413a2441e43f2ce20e22f.svg";
export { ForwardRef as ReactComponent };